import useShowSuccess from 'hooks/useShowSuccess'
import { useProcessTransactionMutation } from '../../../graphql'

export default function useProcessTransactionHandler( options?: any ) {
	const [ processTransaction ] = useProcessTransactionMutation( options )
	const showSuccess = useShowSuccess()

	return async( transactionId: number ) => {
		await processTransaction( { variables: { transactionId } } )
		showSuccess( `processTransaction${Date.now()}`, 'Approval successful' )
	}
}
